import { COURSE_TYPES } from 'constants/common';

export const getLessonPathByCourseType = ({
  courseType,
  courseId,
  lessonId,
}: {
  courseType: any;
  courseId: string;
  lessonId: string;
}) => {
  switch (courseType) {
    case COURSE_TYPES.LEARNING_PATH: {
      return `/learning-path/courses/${courseId}/lessons/${lessonId}`;
    }
    case COURSE_TYPES.COURSE: {
      return `/courses/${courseId}/lessons/${lessonId}`;
    }
    case COURSE_TYPES.TRAINING: {
      return `/trainings/${courseId}/lessons/${lessonId}`;
    }
    case COURSE_TYPES.DAILY_CHALLENGE: {
      return `/daily-challenges/${courseId}/lessons/${lessonId}`;
    }
    case COURSE_TYPES.ARCADE: {
      return `/arcades/${courseId}/lessons/${lessonId}`;
    }
    default: {
      return `/courses/${courseId}/lessons/${lessonId}`;
    }
  }
};

export const getLessonPreviewPathByCourseType = (args: {
  courseType: any;
  courseId: string;
  lessonId: string;
}) => `${getLessonPathByCourseType(args)}/preview`;

export const getCourseEditorPathByType = ({
  courseType,
  courseId,
}: {
  courseType: any;
  courseId: string;
}) => {
  switch (courseType) {
    case COURSE_TYPES.LEARNING_PATH: {
      return `/learning-path/courses/${courseId}`;
    }
    case COURSE_TYPES.TRAINING: {
      return `/trainings/${courseId}`;
    }
    case COURSE_TYPES.DAILY_CHALLENGE: {
      return `/daily-challenges/${courseId}`;
    }
    case COURSE_TYPES.ARCADE: {
      return `/arcades/${courseId}`;
    }
    case COURSE_TYPES.COURSE: {
      return `/courses/${courseId}`;
    }
    default: {
      return `/courses/${courseId}`;
    }
  }
};
